import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { WaitlistEntryListDto } from '@/features/dashboard/waitlist/types/WaitlistEntryListDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ParticipantBookingSpecification } from '@/features/public/booking/types/BookingSpecificationRequest.ts';
import { BookingOptionDto } from '@/features/public/booking/types/BookingOptionDto.ts';

const waitlistApi = {
  getGlobalAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<WaitlistEntryListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<WaitlistEntryListDto>>(
      'POST',
      `waitlist/all?${params.toString()}`,
      filterCriteria,
    );
  },

  getGlobalTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      'waitlist/table-definition',
    );
  },

  getAll: async (
    tourId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<WaitlistEntryListDto>> => {
    const params = buildPageRequestParams(pageRequest);

    return await fetchPrivateApi<PagedDto<WaitlistEntryListDto>>(
      'POST',
      `tours/${tourId}/waitlist/all?${params.toString()}`,
      filterCriteria,
    );
  },

  getTableDefinition: async (tourId: string): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `tours/${tourId}/waitlist/table-definition`,
    );
  },

  getTourOptions: async (
    tourId: string,
    participant: ParticipantBookingSpecification,
  ): Promise<BookingOptionDto[]> => {
    return await fetchPrivateApi<BookingOptionDto[]>(
      'POST',
      `tours/${tourId}/tour-options`,
      participant,
    );
  },
};

export default waitlistApi;
